import Swal from "sweetalert2";

const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
});

export const swalCustom = Swal.mixin({
  customClass: { confirmButton: "btn btn-primary m-1", cancelButton: "btn btn-outline-secondary m-1" },
  buttonsStyling: false,
});

export function toastSuccess(title = "บันทึกแล้ว") { return toast.fire({ icon: "success", title }); }
export function toastError(title = "ทำรายการไม่สำเร็จ") { return toast.fire({ icon: "error", title, timer: 4000 }); }
export function toastInfo(title) { return toast.fire({ icon: "info", title }); }

export function confirmDialog({ title = "ยืนยันการทำรายการ", text = "", icon = "warning", confirmText = "ตกลง", cancelText = "ยกเลิก", html } = {}) {
  return swalCustom.fire({
    title, text, html, icon, showCancelButton: true, reverseButtons: true,
    confirmButtonText: confirmText, cancelButtonText: cancelText,
  }).then((r) => r.isConfirmed);
}

export function alertError(message) {
  return swalCustom.fire({ icon: "warning", html: `<div style="white-space:pre-line;text-align:left">${escapeHtml(message)}</div>`, confirmButtonText: "ปิด" });
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}
